// extracted by mini-css-extract-plugin
export default {"onboarding__buttonGroup":"Onboarding_onboarding__buttonGroup__l1BHq","onboarding__dataButton":"Onboarding_onboarding__dataButton__Durj4"};